export default __webpack_public_path__ + "static/media/footer1.01d44411.jpg";